import React from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { authHeader } from "../_helpers";
import "react-light-accordion/demo/css/index.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SideMenu from "./SideMenu";
import Header from "./Header";

class ChallengesPage extends React.Component {
  constructor() {
    super();
    this.onFileUploadStudent = this.onFileUploadStudent.bind(this);
    this.onFileUploadResult = this.onFileUploadResult.bind(this);
    this.onFileChangeStudent = this.onFileChangeStudent.bind(this);
    this.onFileChangeResult = this.onFileChangeResult.bind(this);
    this.state = {
      quizName: "",
      quizDate: "",
      quizYear: "",
      course: "",
      subjectsCount: "",
      subjects: "",
      challengeName: "",
      unmappedQuizzes: [],
      challengesData: []
    };
    this.state = {
      showChallenge: false,
      showHide: false
    };
  }

  state = {
    selectedStudentFile: null,
    selectedResultFile: null
  };

  componentDidMount() {
    this.fetchUnmappedQuizzes();
    this.fetchChallengeNames();
  }

  onShowChallenge() {
    this.uncheckAll();
    this.setState({ showChallenge: !this.state.showChallenge });
  }

  handleModalShowHide(challengeName) {
    this.uncheckAll();
    if (challengeName == undefined) {
      this.setState({
        showHide: !this.state.showHide,
        challengeName: ""
      });
    }
    else {
      this.setState({
        showHide: !this.state.showHide,
        challengeName: challengeName
      });
    }
  }

  onFileChangeStudent(e) {
    this.setState({ selectedStudentFile: e.target.files[0] });
  }

  onFileChangeResult(e) {
    this.setState({ selectedResultFile: e.target.files[0] });
  }

  onFileUploadStudent = event => {
    event.preventDefault();
    if (this.state.selectedStudentFile) {
      let file = this.state.selectedStudentFile;
      let filename = this.state.selectedStudentFile.name;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("filename", filename);
      const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: formData
      };

      let url = "http://15.206.132.121:3002/api/studentData";
      return fetch(url, requestOptions)
        .then(response => response.json())
        .then(data => {
          if (!data.success) {
            toast.error(data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined
            });
          } else {
            toast.success("File uploaded successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined
            });
          }
        })
        .catch(err =>
          toast.error(err, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          })
        );
    } else {
      toast.error("Please choose file to upload", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
    }
  };

  onFileUploadResult = event => {
    event.preventDefault();
    if (this.state.selectedResultFile) {
      let file = this.state.selectedResultFile;
      let filename = this.state.selectedResultFile.name;
      const data = new FormData();
      data.append("file", file);
      data.append("filename", filename);
      const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: data
      };
      let url = "http://15.206.132.121:3002/api/quizResultData";
      return fetch(url, requestOptions)
        .then(response => response.json())
        .then(data => {
          if (!data.success) {
            toast.error(data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined
            });
          } else {
            toast.success("File uploaded successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined
            });
          }
        })
        .catch(err =>
          toast.error(err, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          })
        );
    } else {
      toast.error("Please choose file to upload", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
    }
  };

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  submitChallengeCreation = e => {
    debugger;
    e.preventDefault();
    let quizIds = "";
    let challengeName = this.state.challengeName;
    let unmappedQuizzes = this.state.unmappedQuizzes;
    for (let i = 0; i < unmappedQuizzes.length; i++) {
      if (unmappedQuizzes[i].isChecked == true) {
        quizIds = quizIds.concat(unmappedQuizzes[i].QuizID);
        quizIds = quizIds.concat(',')
      }
    }
    if (quizIds == "") {
      quizIds = null;
    }
    else {
      quizIds = quizIds.slice(0, -1);
    }
    let user = JSON.parse(localStorage.getItem("user"));

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.data.accessToken
      },
      body: JSON.stringify({
        quizIds,
        challengeName
      })
    };
    let url = "http://15.206.132.121:3002/api/addUpdateChallenge";
    return fetch(url, requestOptions)
      .then(response => response.json())
      .then(res => {
        if (!res.success) {
          throw res.message;
        }
        toast.success("Challenge Created/Updated Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
        this.fetchUnmappedQuizzes();
        this.fetchChallengeNames();
        this.setState({
          challengeName: ""
        });
      })
      .catch(err =>
        toast.error("Failed: Either Challenge name already exists or No QUIZ Mapping", {
          position: "top-right",
          autoClose: 9000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        })
      );
  };

  uncheckAll = () => {
    let unmappedQuizzes = this.state.unmappedQuizzes;
    for (let i = 0; i < unmappedQuizzes.length; i++) {
      unmappedQuizzes[i].isChecked = false;
    }
    this.setState({
      unmappedQuizzes: unmappedQuizzes
    });
  }

  handleCheckbox = e => {
    e.persist();
    let quizId = e.target.value;
    let isChecked = e.target.checked;
    let unmappedQuizzes = this.state.unmappedQuizzes;
    for (let i = 0; i < unmappedQuizzes.length; i++) {
      if (unmappedQuizzes[i].QuizID == quizId) {
        unmappedQuizzes[i].isChecked = isChecked;
      }
    }
    this.setState({
      unmappedQuizzes: unmappedQuizzes
    });
  };

  fetchUnmappedQuizzes = () => {
    let user = JSON.parse(localStorage.getItem("user"));
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.data.accessToken
      }
    };
    let url = "http://15.206.132.121:3002/api/getNonMappedQuizes";
    return fetch(url, requestOptions)
      .then(response => response.json())
      .then(data => {
        let unmappedQuizzes = data.data;
        if (unmappedQuizzes) {
          for (let i = 0; i < unmappedQuizzes.length; i++) {
            unmappedQuizzes[i].isChecked = false;
          }
        }
        this.setState({
          unmappedQuizzes: unmappedQuizzes
        });
      });
  };

  openModal() {
    this.setState({ showModal: true });
  }

  handleModalCloseClick() {
    this.setState({ showModal: false });
  }

  fetchChallengeNames = () => {
    let user = JSON.parse(localStorage.getItem("user"));
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.data.accessToken
      }
    };
    let url = "http://15.206.132.121:3002/api/getAllChallenges";
    return fetch(url, requestOptions)
      .then(response => response.json())
      .then(data => {
        let challengesData = data.data;
        this.setState({ challengesData: challengesData });
      });
  };

  deleteChallenge = challengeId => {
    let result = window.confirm(
      "Are you sure you want to delete this challenge"
    );
    if (result) {
      let user = JSON.parse(localStorage.getItem("user"));
      const requestOptions = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.data.accessToken
        },
      };
      let url = `http://15.206.132.121:3002/api/deleteChallenge?challengeId=${challengeId}`;
      fetch(url, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (!data.success) {
            throw data.message
          }
          this.fetchChallengeNames();
          this.fetchUnmappedQuizzes();
          toast.success("Challenge Deleted successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          });
        })
        .catch((err) => {
          toast.error("Either System Error Or Challenge contains Quizzes", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
    }
  };

  render() {
    const { challengeName, unmappedQuizzes, challengesData } = this.state;
    return (
      <div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        <Modal show={this.state.showHide} className="in">
          <Modal.Header closeButton onClick={() => this.handleModalShowHide()}>
            <Modal.Title>Select Quiz</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <strong>{this.state.challengeName}</strong>
            <br />

            {unmappedQuizzes && unmappedQuizzes.length > 0 ? (
              unmappedQuizzes.map((quiz, index) => {
                return (
                  <div
                    className="form-check"
                    key={quiz.QuizID}
                    style={{ marginBottom: "2px" }}
                  >
                    <input
                      className="form-check-input"
                      id={quiz.QuizId}
                      type="checkbox"
                      value={quiz.QuizID}
                      name={quiz.QuizId}
                      onChange={this.handleCheckbox}
                    />{" "}
                    {quiz.QuizName}
                  </div>
                );
              })
            ) : (
                "No Quiz available to map"
              )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.handleModalShowHide()}
            >
              Close
            </Button>
            <Button variant="primary" onClick={this.submitChallengeCreation}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        <section id="container">
          <Header />
          <SideMenu />
          <section id="main-content">
            <section className="wrapper">
              <div>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.onShowChallenge()}
                >
                  {this.state.showChallenge ? "Show Challenges" : "Create Challenge"}
                </button>
              </div>
              <form
                className={
                  this.state.showChallenge ? "collapse in" : "collapse"
                }
                onSubmit={this.submitChallengeCreation}
              >
                <div className="contact">
                  <div className="row">
                    <div className="col-md-12">
                      <div
                        className="contact-form"
                        style={{
                          padding: "4%"
                        }}
                      >
                        <div className="form-group ">
                          <label
                            className="control-label col-sm-3"
                            htmlFor="challengeName"
                          >
                            Challenge Name:
                          </label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              name="challengeName"
                              value={challengeName}
                              onChange={this.onChange}
                              className="form-control"
                              placeholder="Enter Challenge Name"
                              required
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="control-label col-sm-3" htmlFor="">
                            Select Quizzes:
                          </label>
                          <div className="col-sm-9 mt-2">
                            {unmappedQuizzes && unmappedQuizzes.length > 0 ? (
                              unmappedQuizzes.map((quiz, index) => {
                                return (
                                  <div
                                    className="form-check"
                                    key={quiz.QuizID}
                                    style={{ marginBottom: "2px" }}
                                  >
                                    <input
                                      className="form-check-input"
                                      id={quiz.QuizId}
                                      type="checkbox"
                                      value={quiz.QuizID}
                                      name={quiz.QuizId}
                                      onChange={this.handleCheckbox}
                                    />{" "}
                                    {quiz.QuizName}
                                  </div>
                                );
                              })
                            ) : (
                                "No Quiz available to map"
                              )}
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="col-sm-12">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              style={{
                                float: "right"
                              }}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <div
                className={`scroll-fit ${this.state.showChallenge
                  ? "collapse"
                  : "collapse in"}`}
              >
                <table className="table  table-hover general-table">
                  <thead>
                    <tr>
                      <th> S.No</th>
                      <th>Challenge Name</th>
                      <th>Created On</th>
                      <th>Associated Quizzes</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {challengesData &&
                      challengesData.length > 0 &&
                      challengesData.map((challenge, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{challenge.ChallengeName}</td>
                            <td>{challenge.CreatedDate}</td>
                            <td>{challenge.AssociatedQuizzes}</td>
                            <td>
                              <button
                                className="btn btn-primary mr-4"
                                onClick={() =>
                                  this.handleModalShowHide(
                                    challenge.ChallengeName
                                  )}
                              >
                                Associate Quiz
                              </button>
                              <button
                                className="btn btn-primary" style={{ marginTop: "5px", marginRight: "4px" }}
                                onClick={() =>
                                  this.deleteChallenge(challenge.ChallengeId)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </section>
          </section>
        </section>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedHomePage = connect(mapStateToProps)(ChallengesPage);
export { connectedHomePage as ChallengesPage };
